module.exports = {"component":"checkbox","status":"prod","display-name":"Checkboxes","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/checkbox","url-slug":"checkboxes"}


//////////////////
// WEBPACK FOOTER
// ./components/checkbox/docs.json
// module id = 165
// module chunks = 0